import openPopup from "../../popups/popups.js"

const forms = document.querySelectorAll("[data-js-form]")

forms.forEach((form) => {
  form.addEventListener("submit", (e) => {
    e.preventDefault()

    const btn = form.querySelector(".btn")
    btn.classList.add("_preload")

    const actionUrl = form.getAttribute("action")
    $.post(actionUrl, $(form).serialize()).done(() => {
      btn.classList.remove("_preload")
      const target = document.querySelector(`[data-popup=${form.dataset.popupTarget}]`)
      openPopup(target)
    })
  })
})



// WEBPACK FOOTER //
// ./src/blocks/footer/contacts/form.js